import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

/* Fade-up on scroll into view */
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

/* Line-by-line mask reveal for headlines (on-load) */
export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, stagger = 0.12 }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-line" aria-hidden="true">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.95, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

/* Eyebrow label with a leading rule */
export const Eyebrow = ({ children, light = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span
      className={`h-px w-8 ${light ? "bg-electric-bright/60" : "bg-electric/50"}`}
    />
    <span
      className={`eyebrow ${light ? "text-electric-ice/80" : "text-electric"}`}
    >
      {children}
    </span>
  </div>
);
